<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'partnersPage.bundleForm.editBundle' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="dismiss()"
    ></i>
  </div>
  <div class="modal-body" [formGroup]="bundleForm">
    <div class="row mb-1 align-items-end">
      <p class="caption mb-1 col-12">
        {{
          'partnersPage.titleBundles' | translate: { partner: partner().name }
        }}
      </p>
    </div>
    <hr class="mt-0 mb-3" />

    <div class="row mb-3">
      <div class="col-12">
        <div class="notes">
          {{ 'partnersPage.bundleForm.priceWarning' | translate }}
        </div>
      </div>
    </div>

    <app-data-table-assign
      formControlName="selectedBundles"
      [configuration]="bundleAssignConfiguration"
    ></app-data-table-assign>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-clear"
      (click)="dismiss()"
      data-cy="close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="isLoading() || !hasPendingChanges()"
      data-cy="save-bundles-btn"
    >
      @if (isLoading()) {
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
      }
      {{ 'common.buttons.btnSave' | translate }}
    </button>
  </div>
</div>

<ng-template #assignedBundleNameTemplate let-row="row">
  {{ row.bundle.internalName }}

  @if (!row.bundleConfigurationId) {
    <span class="badge bg-success ms-2">{{
      'partnersPage.infoBadges.new' | translate
    }}</span>
  }

  @if (row.bundle?.deactivated) {
    <span
      class="badge bg-warning ms-2"
      triggers="hover"
      [ngbTooltip]="'partnersPage.tooltips.bundleDeactivated' | translate"
      >{{ 'partnersPage.infoBadges.deactivated' | translate }}
    </span>
  }

  @if (!(isBundleAvailable(row.bundle?.id) | async)) {
    <span
      class="badge bg-danger ms-2"
      triggers="hover"
      [ngbTooltip]="'partnersPage.tooltips.bundleNotAvailable' | translate"
      >{{ 'partnersPage.infoBadges.notAvailable' | translate }}
    </span>
  }
</ng-template>

<ng-template #availableBundleNameTemplate let-row="row">
  {{ row.bundle.internalName }}
</ng-template>
